// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"467ebb11","349":"44313b79","359":"73e8c829","753":"a3579883","923":"d1bc430f"}[chunkId] + ".chunk.js";
};